import { toast } from "react-toastify";
import { buildCharacterizationCsvFiles } from "./buildCharacterizationCsvFiles";
import {
  downloadCsvFiles,
  fetchCsvExportDatasets,
  getMaterialCatalogFromStorage,
} from "./csvExportShared";

/**
 * Unitary CSV export for one characterization report.
 * Regulation is derived from container.type (OMR zone → RHW, else classic + 1199 recap).
 */
export const exportCsvFromRow = async ({
  period,
  container,
  superContainer,
  i18n,
  t,
  onProgress,
  useLatestCoefficients = false,
}) => {
  const reportProgress = (percent, labelKey) => {
    onProgress?.({
      percent,
      label: labelKey ? t(labelKey) : "",
    });
  };

  if (!period || !container) {
    toast.error(t("No data available for export"));
    return;
  }

  try {
    reportProgress(10, "Loading...");
    const {
      regulationType,
      clientThresholdCm,
      clientThresholdData,
      decreeData,
    } = await fetchCsvExportDatasets({
      period,
      container,
      superContainer,
      i18n,
      useLatestCoefficients,
    });

    if (!clientThresholdData && !decreeData) {
      toast.error(t("No data available for export"));
      return;
    }

    reportProgress(70, "Loading...");
    const csvFiles = buildCharacterizationCsvFiles({
      period,
      container,
      t,
      locale: i18n.language,
      clientThresholdCm,
      clientThresholdData: clientThresholdData || decreeData,
      decreeData: decreeData || clientThresholdData,
      materialCatalog: getMaterialCatalogFromStorage(),
      regulationType,
    });

    if (csvFiles.length === 0) {
      toast.error(t("No data available for export"));
      return;
    }

    reportProgress(90, "Loading...");
    await downloadCsvFiles(csvFiles);
    reportProgress(100, "Loading...");
    toast.success(
      `${csvFiles.length} ${t("downloaded_files") || "fichiers téléchargés"}`,
    );
  } catch (error) {
    console.error("Error generating CSV:", error);
    toast.error(t("Error generating CSV"));
  }
};
